import {translations} from 'locales/translations';
import {__} from 'utils/messages';

export default {
  linkedDocuments: () => __(translations.commercialDocumentComponents.linkedDocuments, 'Linked documents'),
};
